import { render } from "./BankView.vue?vue&type=template&id=4530e55d&scoped=true"
import script from "./BankView.vue?vue&type=script&lang=js"
export * from "./BankView.vue?vue&type=script&lang=js"

import "./BankView.vue?vue&type=style&index=0&id=4530e55d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4530e55d"]])

export default __exports__